<template>
  <div v-if="companyContactPartnersPage" class="con-tablex vs-table--content">
    <template v-for="contact of companyContactPartnersPage.results.slice(0, 2)">
      <div :key="contact.id" class="actions-card-item">
        <div class="actions-card-item-name">
          <b
            >{{ salutations[contact.salutation] }} {{ contact.firstName }}
            {{ contact.lastName }}</b
          >

          <ul>
            <li>
              <i class="fal fa-envelope mr-2"></i>
              <a :href="` mailto:${contact.email} `" class="text-black">
                {{ contact.email }}
              </a>
            </li>
            <li>
              <i class="fal fa-phone-alt mr-2"></i>
              <a :href="` callto:${contact.telephone} `" class="text-black">
                {{ contact.telephone }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-if="!companyContactPartnersPage.results.length">
      Keine Einträge
    </template>
  </div>
</template>

<script>
import gql from "graphql-tag";
import salutations from "@/data/enums/Salutation.js";

export default {
  data() {
    return {
      syncOpen: {},
      salutations
    };
  },
  apollo: {
    companyContactPartnersPage: {
      query: gql`
        query Company($company: ID!) {
          companyContactPartnersPage(company: $company) {
            results {
              id
              salutation
              firstName
              lastName
              position
              department
              telephone
              telephoneMobile
              email
            }
          }
        }
      `,
      variables() {
        return {
          company: this.$route.params.id
        };
      }
    }
  }
};
</script>
<style scoped>
.accordion-content {
  overflow: hidden;
  transition: height 0.2s ease-out;
}
</style>
